/**
 * Form Validation
 *
 * Just requiring jquery-validation-unobtrusive is enough to have it function on anything with data-val="true".
 * When using jquery-validation without unobtrusive, call $(selector).validate(options)
 *
 * Usage:
 * Call FormValidation.init() to initialize on all inputs with data-val="true"
 *
 * Methods:
 *
 * init(): initialize jquery-validation-unobtrusive and validation-feedback functionalities
 *
 * Dependencies:
 * - jquery
 * - jquery-validation: https://jqueryvalidation.org/
 * - jqueury-validation-unobtrusive: https://github.com/aspnet/jquery-validation-unobtrusive
 */

const $ = require('jquery');
require('jquery-validation');
require('jquery-validation-unobtrusive');

const init = function() {
	// "Yes Validation is not performed for checkboxes because the programmers that wrote the adapter says that required is different fro mandatory and in my opinion he is right. A required validation attribute must trigger if no value is provided! An unchecked checkbox has a a value: the false value!"
	// Explanation: https://forums.asp.net/t/1648319.aspx?MVC+3+Unobtrusive+validation+does+not+work+with+checkboxes+jquery+validation+and+the+fix+for+it+
	// Script: http://itmeze.com/2010/12/checkbox-has-to-be-checked-with-unobtrusive-jquery-validation-and-asp-net-mvc-3/
	$.validator.unobtrusive.adapters.add('mandatory', options => {
		options.rules.required = true;
		if (options.message) {
			options.messages.required = options.message;
		}
	});

	$.validator.unobtrusive.adapters.addBool('mandatory', 'required');

	// Textarea autoheight
	$('.js-textarea-autoheight').on('input', function() {
		$(this).css('height', '');
		const { scrollHeight } = $(this).get(0);
		$(this).css('height', `${scrollHeight}px`);
	});

	// Trigger submit on click
	$('.js-trigger-submit').on('click', function() {
		// jQuery's .submit() triggers event that is captured by jQuery Validator. ECMA .submit() does not
		$(this.closest('form')).submit();
	});

	// Trigger clear input
	$('.js-trigger-clear').on('click', function() {
		$(this).next('input').val('');
	});

	// Form disabled until valid
	document.querySelectorAll('.js-form-disabled-until-valid').forEach($form => {
		const $submits = $form.querySelectorAll('[type=submit]');

		function checkIfAllRequiredsHaveValue() {
			const $inputs = $form.querySelectorAll(
				'input[required], textarea[required], select[required]'
			);
			const $emptys = Array.from($inputs).filter($el => {
				let retval;
				if ($el.type === 'radio' || $el.type === 'checkbox') {
					retval = !$el.checked;
				} else {
					retval = $el.value === '';
				}
				return retval;
			});
			return $emptys.length === 0;
		}

		function setSubmitsDisabled(state) {
			$submits.forEach($submit => {
				$submit.disabled = state;
			});
		}

		let prevDisabledState = true;
		setSubmitsDisabled(prevDisabledState);
		$form.addEventListener('input', () => {
			if (checkIfAllRequiredsHaveValue()) {
				const newDisabledState = !$($form).valid();
				if (prevDisabledState !== newDisabledState) {
					setSubmitsDisabled(newDisabledState);
					prevDisabledState = newDisabledState;
				}
			} else {
				setSubmitsDisabled(true);
				prevDisabledState = true;
			}
		});
	});

	// Validator highlight/unhighlight
	$.validator.defaults.highlight = function(element, errorClass, validClass) {
		$(element)
			.closest('.field')
			.addClass('is-error')
			.removeClass('is-success');
	};
	$.validator.defaults.unhighlight = function(element, errorClass, validClass) {
		$(element)
			.closest('.field')
			.removeClass('is-error')
			.addClass('is-success');
	};

	// Stripped code recevied from FokkerServices by Adeline Schäfer https://service.thevalley.nl/browse/FC-220
	// Handles newsletter sign ups
	/* eslint-disable */
	// Is used by the proc script, runs after succesful submit
	function newsletterSignup() {
		const forms_to_submit = document.querySelectorAll('.js-fs_form');
		window._show_thank_you = function(id, message, trackcmp_url) {
			forms_to_submit.forEach(form => {
				// Look for the valid form so we only edit that one
				if ($(form).validate().successList.length > 0) {
					var thank_you = form.querySelector('.js-fs_form-thank-you');
					form.querySelectorAll('.js-fs_form-content').forEach($el => {
						$el.style.display = 'none';
					});
					thank_you.style.display = 'block';
				}
			});
			if (typeof trackcmp_url != 'undefined' && trackcmp_url) {
				// Site tracking URL to use after inline form submission.
				_load_script(trackcmp_url);
			}
			if (typeof window._form_callback !== 'undefined') window._form_callback(id);
		};
		// Is used by the proc script, runs after unsuccesful submit
		window._show_error = function(id, message) {
			forms_to_submit.forEach(form => {
				// We still check for .valid() because we did submit, meaning it's the valid form
				if ($(form).validate().successList.length > 0) {
					const button = form.querySelector('.js-fs_form_submit');
					if (button) {
						button.disabled = false;
					}
					var validator = $(form).validate();
					validator.showErrors({
						email: message
					});
				}
			});
		};
		window._load_script = function(url, callback) {
			var head = document.querySelector('head'),
				script = document.createElement('script'),
				r = false;
			script.type = 'text/javascript';
			script.charset = 'utf-8';
			script.src = url;
			if (callback) {
				script.onload = script.onreadystatechange = function() {
					if (!r && (!this.readyState || this.readyState == 'complete')) {
						r = true;
						callback();
					}
				};
			}
			head.appendChild(script);
		};
		if (window.location.search.search('excludeform') !== -1) return false;
		var addEvent = function(element, event, func) {
			var oldFunc = element['on' + event];
			element['on' + event] = function() {
				if (oldFunc) {
					oldFunc.apply(this, arguments);
				}
				func.apply(this, arguments);
			};
		};

		forms_to_submit.forEach(form_to_submit => {
			window._old_serialize = null;
			if (typeof serialize !== 'undefined') window._old_serialize = window.serialize;
			_load_script(
				'//d3rxaij56vjege.cloudfront.net/form-serialize/0.3/serialize.min.js',
				function() {
					window._form_serialize = window.serialize;
					if (window._old_serialize) window.serialize = window._old_serialize;
				}
			);
			var form_submit = function(e) {
				e.preventDefault();
				if ($(form_to_submit).valid()) {
					// use this trick to get the submit button & disable it using plain javascript
					const button = form_to_submit.querySelector('.js-fs_form_submit');
					if (button) {
						button.disabled = true;
					}
					var serialized = _form_serialize(form_to_submit);
					var err = form_to_submit.querySelector('.js-fs_form_error');
					err ? err.parentNode.removeChild(err) : false;
					// Runs for example: _show_thank_you("19", "Thanks for signing up!", "https://prism.app-us1.com?a=89646274&e=test%40thevalley.nl");
					// Runs for example: _show_error("19", "E-mail address is invalid.");
					// Runs for example: window.top.location.href = "https://prism.app-us1.com/redirect?a=89646274&e=test%40thevalley.nl&u=https%3A%2F%2Ftrackcmp.net%2Fredir%3Factid%3D89646274%26url%3DaHR0cHM6Ly9mb2trZXJzZXJ2aWNlcy5hY3RpdmVob3N0ZWQuY29tL2YvY29uZmlybS5waHA%252FaWQ9MjAmcz0xOGQyYjMzNDM5NDI3NDY2MmM1YjQzZDZiOGZhNmQ5Yg%253D%253D%26e%3DiTjyZVYcCozb57H1mVy9mjwkAFoUGpvqbnyrg12fOoc%253D";
					_load_script(
						'https://fokkerservices.activehosted.com/proc.php?' +
						serialized +
						'&jsonp=true'
					);
				}
				return false;
			};
			addEvent(form_to_submit, 'submit', form_submit);
		});
	}
	newsletterSignup();

	// Stripped code from FokkerServices ActiveCampaign https://service.thevalley.nl/browse/FC-367 this time extracted ourselves by logging into ActiveCampaign
	function subscriptionPopup() { }
	subscriptionPopup();
};

module.exports = {
	init
};
